import { postToApiPath } from '../shared/utilities/apiClient';
import { BulkFormActionResult } from '../types/bulkFormActionResult';

export const bulkSendStatusDownstream = (
    formIds: string[],
    toastText?: {
        onPendingText?: string;
    }
) =>
    postToApiPath<BulkFormActionResult>(
        'testapp/forms/bulk/status-downstream',
        { formIds },
        {
            headers: {
                'Toast-Pending-Text': toastText?.onPendingText,
                SkipSuccessToast: true,
            },
        }
    )
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
